import React from "react";

export const leafCircleFilled = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
      <path
        fill="currentColor"
        d="M12 0c6.627 0 12 5.372 12 12 0 6.627-5.372 12-12 12-6.627 0-12-5.373-12-12C0 5.372 5.373 0 12 0m-.336 4.682c-.054.03-1.349.742-2.646 2.106-1.744 1.833-2.666 3.983-2.666 6.217A5.654 5.654 0 0 0 12 18.654a5.654 5.654 0 0 0 5.648-5.647c0-2.235-.922-4.385-2.666-6.218-1.297-1.363-2.59-2.075-2.646-2.106L12 4.5zm-.367 10.607v1.9a4.25 4.25 0 0 1-3.54-4.183q0-.233.017-.461zm4.93-2.744q.015.226.015.46a4.25 4.25 0 0 1-3.54 4.184v-1.9zm-1.173-3.409c.356.552.666 1.17.88 1.855l-3.232 2.516v-2.54zm-3.757 1.83v2.54L8.063 10.99a7.5 7.5 0 0 1 .88-1.857zm0-1.78-1.5-1.169q.103-.116.211-.23c.45-.477.903-.867 1.29-1.164zm1.405-2.563c.445.344.981.81 1.5 1.395l-1.5 1.167z"
      />
    </svg>
  );
};
